import { memo } from 'react';
import { and, EnumCellProps, isEnumControl, RankedTester, rankWith, WithClassname } from '@jsonforms/core';
import { TranslateProps, withJsonFormsEnumCellProps, withTranslateProps } from '@jsonforms/react';
import Autocomplete from './component';

export const MaterialEnumCell = (props: EnumCellProps & WithClassname & TranslateProps) => <Autocomplete {...props} />;

/**
 * Default tester for enum controls.
 * @type {RankedTester}
 */
export const materialEnumCellTester: RankedTester = rankWith(5, and(isEnumControl));

export default withJsonFormsEnumCellProps(withTranslateProps(memo(MaterialEnumCell)), false);
